import {
  http
} from '../config';
import base from './base';

export const leave={
  queryLeaveList(data){
    return http({
      url:`${base.users}/tea/queryLeaveList`,
      method:'post',
      data
    });
  },
  cancelLeave(thId){
    return http({
      url:`${base.users}/tea/cancelLeave/${thId}`,
      method:'get',
    });
  },
  addLeaveRecord(data){
    return http({
      url:`${base.users}/tea/addLeaveRecord`,
      method:'post',
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/leave.js